import { RouteConfig } from '../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'order-history',
  path: () => '/order-history',
  type: 'private',
}

export default ROUTE
